import React from 'react';
import PropTypes from 'prop-types';
import { BanjoString } from '@stashinvest/react-banjo';
import { CloseIcon } from '@stashinvest/ui';
import { OneString, FullSheet } from '@stashinvest/react-components';
import { TRADITIONAL_IRA, ROTH_IRA } from 'stash/constants/accountTypes';

const DetailHeader = ({ children }) => (
	<OneString className="pb-contentSmall" color="lead" textStyle="headerSmall">
		{children}
	</OneString>
);

const DetailContent = ({ children }) => (
	<OneString className="pb-contentSmall" color="lead" textStyle="bodySmallStandard">
		{children}
	</OneString>
);

const RothIRADetails = () => {
	return (
		<>
			<DetailHeader>
				<BanjoString stringId="information/giveTerm/rothIRAExplain" />
			</DetailHeader>
			<DetailContent>
				<BanjoString stringId="information/explainTerm/rothIRA" />
			</DetailContent>
		</>
	);
};

const TraditionalIRADetails = () => {
	return (
		<>
			<DetailHeader>
				<BanjoString stringId="information/giveTerm/traditionalIRAExplain" />
			</DetailHeader>
			<DetailContent>
				<BanjoString stringId="information/explainTerm/traditionalIRA" />
			</DetailContent>
		</>
	);
};

const IRA_DETAILS_MAP = {
	[ROTH_IRA]: {
		title: <BanjoString stringId="navigation/locate/rothIRA" />,
		component: RothIRADetails,
	},
	[TRADITIONAL_IRA]: {
		title: <BanjoString stringId="navigation/locate/traditionalIRA" />,
		component: TraditionalIRADetails,
	},
	default: {
		title: 'IRA details',
		component: () => <DetailContent>No details available</DetailContent>,
	},
};

const InfoSheetIRA = ({ iraType, setShowSheet }) => {
	const { title, component: IRADetailsComponent } =
		IRA_DETAILS_MAP[iraType] || IRA_DETAILS_MAP.default;

	return (
		<FullSheet
			navLayout={({ closeSheet }) => <NavLayout handleClose={closeSheet} title={title} />}
			onClose={() => setShowSheet(false)}
			mainLayout={
				<MainLayout>
					<IRADetailsComponent />
				</MainLayout>
			}
		/>
	);
};

const NavLayout = ({ handleClose, title }) => {
	return (
		<nav className="relative flex justify-between items-center h-[48px] my-content3XS mx-content2XS">
			<div>
				<CloseIcon size="1.5rem" onClick={handleClose} data-testid="close-button" />
			</div>
			<div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
				<OneString color="lead" textStyle="header2XS" tag="h1">
					{title}
				</OneString>
			</div>
		</nav>
	);
};

const MainLayout = ({ children }) => {
	return <div className="p-4">{children}</div>;
};

InfoSheetIRA.propTypes = {
	iraType: PropTypes.oneOf([ROTH_IRA, TRADITIONAL_IRA]).isRequired,
	setShowSheet: PropTypes.func.isRequired,
};

export default InfoSheetIRA;
